import { Autocomplete, Checkbox, Chip, Divider, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography, useMediaQuery } from '@mui/material'
import React, { useContext, useState } from 'react'
import styles from './../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss' 
import waCampaignStyles from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"; 
import Required from '../../utility/required'
import GlobalButton from '../../utility/globalButton/button'
import { WorkflowContext, WorkflowContextPayload } from '../../../context/workflowContext'
import { defaultConditionValueObject, initialCreateNewFlowObject, ALLOWED_INTEGRATION_CHANNELS  } from './workflowConstants'
import globalStyles from './../../../assets/styles/global.module.scss'
import WorkflowWhatsappIntegration from './integrationLists/workflowWhatsappIntegration'
import { globalWorkflowIntegrationType } from '../../../models/axiosModel'
import { UserContext, UserContextPayload } from '../../../context/userContext'
import agent from '../../../services/api'
import WorkflowFacebookIntegration from './integrationLists/workflowFacebookIntegration'
import { useNavigate } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close';
import GlobalTooltip from '../../utility/tooltip/globalTooltip';
import IconsColor from '../../utility/iconsColor';
import { primaryColor } from '../../../utils/colors';
import { generateUUID } from '../../../utils/constants';
import { INSTAGRAM_CHATBOT_CONTENT_TYPE, isInstagramChannel, isWhatsAppChannel } from '../../../pages/ruleBasedInbox/channelConstants';
import { checkDisableTriggerKeywordsAndDefault, hours, isMinuteDisabled, minutes, validateTime } from '../flowBuilder/flowBuilderConstants';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import WorkflowInstagramIntegration from './integrationLists/workflowInstagramIntegration';

const CreateWorkflowPopup = () => {
    const navigate = useNavigate()
    const { createNewWorkflowPayload, setCreateNewWorkflowPayload, workflowIntegrationList, chatbotTypes, setFlagNewWorkflowPopup } = useContext(WorkflowContext) as WorkflowContextPayload
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const largeScreen = useMediaQuery('(max-width : 1600px) and (min-width : 0px)');


    const [typedTriggerValue, setTypedTriggerValue] = useState<string>(""); 

    const innerHeight = window.innerHeight - 250; 

    const handleChangeCreateWorkflowPayload = (field_name: string, value: string | number) => {
        let DMExist = workflowIntegrationList?.find((integrationList) => integrationList.channel_id == value)?.channel_content_types?.find((types) => types?.channel_content_type_name?.toLowerCase() == "dm")
        if (field_name == "channel_id") {
            setCreateNewWorkflowPayload({ ...createNewWorkflowPayload, [field_name]: Number(value), chatbot_channel_configuration: DMExist ? { channel_content_type_id: DMExist.channel_content_type_id.toString() } : null })
        }
        else {
            setCreateNewWorkflowPayload({ ...createNewWorkflowPayload, [field_name]: value })
        }
    }

    const handleChangeContentType = (value: any) => {
        if (value) {
            setCreateNewWorkflowPayload({ ...createNewWorkflowPayload, chatbot_channel_configuration: { ...createNewWorkflowPayload?.chatbot_channel_configuration, channel_content_type_id: value?.channel_content_type_id?.toString() } })
        }
        else {
            setCreateNewWorkflowPayload({ ...createNewWorkflowPayload, chatbot_channel_configuration: createNewWorkflowPayload?.chatbot_channel_configuration?.integrated_channel_id ? { integrated_channel_id: createNewWorkflowPayload?.chatbot_channel_configuration?.integrated_channel_id } : null })
        }
    }

    const handleResetNewFlow = () => {
        setCreateNewWorkflowPayload(initialCreateNewFlowObject)
    }

    const handleCreateWorkflow = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        let tempPayload = createNewWorkflowPayload
        tempPayload = { 
            ...tempPayload, 
            chatbot_type_id: chatbotTypes?.find((type) => type.chatbot_type_name.toLowerCase() == "workflow")?.chatbot_type_id || "0",
            chatbot_step_deployment_trigger_data: tempPayload.chatbot_step_deployment_trigger_data.filter((trigger) => !(trigger.condition_group) || trigger.condition_group?.condition_values?.length > 0).map((trigger) => {
                return {
                    ...trigger, 
                    chatbot_step_deployment_trigger_data_id: generateUUID(),
                }
            }),
        }
        const res = await agent.createChatbotFlow.post(tempPayload);
        if (res.status) {
            showSuccess("Rule-Based Chatbot Created Successfully!")
            navigate(`/workflow/staticWorkflowDetails?workflow_id=${res?.data[0]?.chatbot_id}`)
        }
        else {
            handleError(res);
        }
        setFlagNewWorkflowPopup(false)
        setCreateNewWorkflowPayload(initialCreateNewFlowObject)
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }

    const isCreateWorkflowDisabled = () => {
        if (createNewWorkflowPayload.chatbot_name == "" 
                || createNewWorkflowPayload.chatbot_name.trim() == "" 
                || !createNewWorkflowPayload.channel_id 
                || !createNewWorkflowPayload?.chatbot_channel_configuration 
                || (!(createNewWorkflowPayload.chatbot_step_deployment_trigger_data?.find((trigger) => trigger.condition_group && trigger.condition_group?.condition_values?.length > 0))) && !createNewWorkflowPayload.chatbot_step_deployment_trigger_data?.find((trigger) => !(trigger.condition_group))
                || !createNewWorkflowPayload?.chatbot_thread_timeout_config?.timeout_duration?.hour 
                || !createNewWorkflowPayload?.chatbot_thread_timeout_config?.timeout_duration?.min
        ) {
            return true
        }
        return false
    }

    const checkDisableClearableForContentType = (integrationChannel: globalWorkflowIntegrationType) => {
        return isWhatsAppChannel(integrationChannel?.channel_name) || isInstagramChannel(integrationChannel?.channel_name);
    }

    const checkDisableContentTypes = (integrationChannel: globalWorkflowIntegrationType, option: any) => {
        return isInstagramChannel(integrationChannel?.channel_name) 
            && (option?.channel_content_type_name?.toLowerCase() !== INSTAGRAM_CHATBOT_CONTENT_TYPE.DM?.toLowerCase());
    }

    const handleCheckContentTypes = () => {
        const integrationChannel = workflowIntegrationList?.find((integrationList) => integrationList.channel_id == createNewWorkflowPayload?.channel_id)
        if (integrationChannel && integrationChannel?.channel_content_types?.length > 0) {
            return <Grid item sx={{ width: "100%" }}>
                <Grid container direction={"column"} gap={"10px"}>
                    <Grid item className={styles.createWorkflowLabelStyle}>
                        Content Type <Required />
                    </Grid>
                    <Grid item>
                        <Autocomplete
                            disableClearable={checkDisableClearableForContentType(integrationChannel)}
                            className={`${globalStyles.autocompleteParaphrasing} ${styles.autoComplete}`}
                            options={integrationChannel?.channel_content_types}
                            getOptionLabel={(option: any) => option.channel_content_type_name ? option.channel_content_type_name : "Content Type"}
                            value={createNewWorkflowPayload?.chatbot_channel_configuration ?
                                integrationChannel?.channel_content_types?.find((data) => data.channel_content_type_id == Number(createNewWorkflowPayload?.chatbot_channel_configuration?.channel_content_type_id))
                                :
                                integrationChannel?.channel_content_types?.find((data) => data.channel_content_type_name.toLowerCase() == "dm") ||
                                null}
                            onChange={(_, value: any) => { handleChangeContentType(value); }}
                            getOptionDisabled={(option) => checkDisableContentTypes(integrationChannel, option)}
                            // disabled={checkDisableAllFields()}
                            renderInput={(params) => <TextField {...params} placeholder="Select Content Type" />}
                            sx={{ padding: "2px 4px !important" }}
                        />
                    </Grid>
                </Grid>
            </Grid>
        }
    }

    const handleDynamicSubOptionFields = () => {
        const integrationChannel = workflowIntegrationList?.find((integrationList) => integrationList.channel_id == createNewWorkflowPayload?.channel_id)
        if (integrationChannel) {
            const integrationChannelName = integrationChannel.channel_name.toLowerCase();
            switch (integrationChannelName) {
                case "whatsapp":
                    return <WorkflowWhatsappIntegration />
                case "facebook":
                    return <WorkflowFacebookIntegration />
                case "instagram":
                    return <WorkflowInstagramIntegration />
            }
        }
    }

    const onChangeOfTimer = (type: string, value: string) => { 
        let current_hour = createNewWorkflowPayload?.chatbot_thread_timeout_config?.timeout_duration?.hour; 
        let current_min =  createNewWorkflowPayload?.chatbot_thread_timeout_config?.timeout_duration?.min;

        const {new_min, new_hour} = validateTime(type, value, current_min, current_hour);

        setCreateNewWorkflowPayload((prev) => ({
            ...prev, 
            chatbot_thread_timeout_config: {
                ...prev.chatbot_thread_timeout_config, 
                timeout_duration: {
                    ...prev.chatbot_thread_timeout_config?.timeout_duration, 
                    hour: new_hour, 
                    min: new_min,
                }
            }
        }))
    } 

    const checkDisableTriggerKeywords = (triggerType: string) => {
        const keywordsValue = createNewWorkflowPayload.chatbot_step_deployment_trigger_data?.find((trigger) => trigger.condition_group)?.condition_group?.condition_values || [];
        const defaultCheck = createNewWorkflowPayload.chatbot_step_deployment_trigger_data?.find((trigger) => !(trigger.condition_group)) ? true: false;
        return checkDisableTriggerKeywordsAndDefault(triggerType, keywordsValue, defaultCheck); 
    } 

    const findChannelByChannelName = <T extends {channel_name: string}> (list: T[] = [], channelName: string): T | undefined => {
        return list?.find((item) => item?.channel_name?.toLowerCase() === channelName?.toLowerCase());
    }

    const optionLabelForIntegrationChannel = (option: globalWorkflowIntegrationType) => {
        const allowedChannel = findChannelByChannelName(ALLOWED_INTEGRATION_CHANNELS, option?.channel_name);
        if(allowedChannel && allowedChannel?.is_disabled){
            return `${option?.channel_name} (coming soon)`
        }
        return option?.channel_name;
    }

    const filterHiddenIntegrationChannels = (options: globalWorkflowIntegrationType[] | null): globalWorkflowIntegrationType[] => {
        return (options || [])
            ?.filter((option: globalWorkflowIntegrationType) =>
                ALLOWED_INTEGRATION_CHANNELS?.some((channel) => channel?.channel_name?.toLowerCase() === option?.channel_name?.toLowerCase())
            )
            ?.sort((a, b) => {
                const aDisabled = findChannelByChannelName(ALLOWED_INTEGRATION_CHANNELS, a?.channel_name)?.is_disabled ? 1 : 0;
                const bDisabled = findChannelByChannelName(ALLOWED_INTEGRATION_CHANNELS, b?.channel_name)?.is_disabled ? 1 : 0;
                return aDisabled - bDisabled;
            });
    };    
    return (
        <Grid container direction={"column"} gap={"15px"} className={globalStyles.zIndex1}>
            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.textCenter}`} padding={"0px 30px 0px 30px"}>
                <Typography className={waCampaignStyles.popupTitleTypography}>
                    Create New Chatbot
                </Typography>
            </Grid>

            <Grid item padding={"0 30px 0 30px"}>
                <Divider className={styles.popupDividerStyle} />
            </Grid>

            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.overflowAuto}`} sx={{ maxHeight: `${innerHeight}px !important`}}>
                <Grid container direction={"column"} padding={"0px 30px 5px 30px"} gap={"15px"}>
                    <Grid item className={globalStyles.fullwidth}>
                        <Grid container direction={"column"} gap={"10px"}>
                            <Grid item className={styles.createWorkflowLabelStyle}>Chatbot Name <Required /></Grid>
                            <Grid item>
                                <TextField
                                    placeholder='Write a name for your Chatbot...'
                                    className={styles.createGlobalTextField}
                                    value={createNewWorkflowPayload.chatbot_name}
                                    onChange={(e) => handleChangeCreateWorkflowPayload("chatbot_name", e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item className={globalStyles.fullwidth}>
                        <Grid container direction={"column"} gap={"10px"}>
                            <Grid item className={styles.createWorkflowLabelStyle}>Integration Channel <Required /></Grid>
                            <Grid item>
                                <Autocomplete
                                    className={`${globalStyles.autocompleteParaphrasing} ${styles.autoComplete}`}
                                    value={workflowIntegrationList?.find((option) => option.channel_id === createNewWorkflowPayload?.channel_id) || null}
                                    onChange={(event: React.SyntheticEvent, value: globalWorkflowIntegrationType | null) => {
                                        handleChangeCreateWorkflowPayload("channel_id", value?.channel_id || '');
                                    }}
                                    options={filterHiddenIntegrationChannels(workflowIntegrationList)}
                                    getOptionLabel={(option) => optionLabelForIntegrationChannel(option)}
                                    getOptionDisabled={(option) => findChannelByChannelName(ALLOWED_INTEGRATION_CHANNELS, option?.channel_name)?.is_disabled ?? false}
                                    renderInput={(params) => <TextField {...params} placeholder='Select Integration Channel...' />}
                                    sx={{ padding: "2px 4px !important" }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    {createNewWorkflowPayload?.channel_id !== 0 && handleCheckContentTypes()}

                    {createNewWorkflowPayload?.channel_id !== 0 && handleDynamicSubOptionFields()} 

                    <Grid item className={globalStyles.fullwidth}>
                        <Grid container direction={"column"} gap={"10px"}>
                            <Grid item className={styles.createWorkflowLabelStyle}>
                                Do you need to trigger this chatbot on any special keyword?
                            </Grid>
                            <Grid item>
                                <Autocomplete
                                    className={`${waCampaignStyles.whatsappCampaignDropDowns} ${globalStyles.fullwidth} ${waCampaignStyles.actionAutoComplete} ${waCampaignStyles.actionUserReplyAutoComplete} ${styles.triggerValueFreeSolo}`}
                                    freeSolo
                                    options={[]}
                                    multiple
                                    value={createNewWorkflowPayload.chatbot_step_deployment_trigger_data?.find((trigger) => trigger.condition_group)?.condition_group?.condition_values || []} 
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                label={option}
                                                deleteIcon={<CloseIcon />}
                                                {...getTagProps({ index })} 
                                                sx={{
                                                    whiteSpace: "normal", 
                                                    wordBreak: "break-word",
                                                    padding: "4px 0px",
                                                    height: "auto",
                                                }}
                                            />
                                        ))
                                    } 
                                    inputValue={typedTriggerValue}
                                    onInputChange={(e, val) => {
                                        setTypedTriggerValue(val);
                                    }}
                                    onChange={(e, newValue) => {
                                        const filtered = newValue.filter((val) => typeof val === "string" && val.trim().length > 0); 

                                        setCreateNewWorkflowPayload((prev) => ({
                                            ...prev, 
                                            chatbot_step_deployment_trigger_data: prev?.chatbot_step_deployment_trigger_data?.map((trigger) => {
                                                if(trigger.condition_group){
                                                    return {
                                                        ...trigger, 
                                                        condition_group: {
                                                            ...trigger.condition_group, 
                                                            condition_values: filtered,
                                                        }
                                                    }
                                                }
                                                return trigger; 
                                            })
                                        }));
                                    }}
                                    renderInput={params => {
                                        const { InputProps, ...restParams } = params;
                                        const { startAdornment, ...restInputProps } = InputProps;
                                        return (
                                            <TextField
                                                {...restParams}
                                                placeholder='Enter Trigger Keywords' 
                                                onBlur={() => {
                                                    if (typedTriggerValue.trim().length > 0) { 
                                                        if(!createNewWorkflowPayload.chatbot_step_deployment_trigger_data?.[0]?.condition_group?.condition_values?.find((val) => val == typedTriggerValue.trim())){
                                                            const existingValues = createNewWorkflowPayload.chatbot_step_deployment_trigger_data?.[0]?.condition_group?.condition_values || [];
    
                                                            const newVal = [...existingValues, typedTriggerValue.trim()];
    
                                                            setCreateNewWorkflowPayload((prev) => ({
                                                                ...prev, 
                                                                chatbot_step_deployment_trigger_data: prev?.chatbot_step_deployment_trigger_data?.map((trigger) => {
                                                                    if(trigger.condition_group){
                                                                        return {
                                                                            ...trigger, 
                                                                            condition_group: {
                                                                                ...trigger.condition_group, 
                                                                                condition_values: newVal,
                                                                            }
                                                                        }
                                                                    }
                                                                    return trigger; 
                                                                })
                                                            }));
    
                                                            setTypedTriggerValue("");
                                                        }
                                                    }
                                                }}
                                                InputProps={{
                                                    ...restInputProps,
                                                    startAdornment: (
                                                        <div className={waCampaignStyles.renderInputDivOfUserReplyOfAction}>
                                                            {startAdornment}
                                                        </div>
                                                    ),
                                                }}
                                            />
                                        );
                                    }} 
                                    disabled={checkDisableTriggerKeywords("keyword")}
                                />
                            </Grid> 
                            {typedTriggerValue.trim().length > 0 && 
                                <Grid item className={styles.pressEnterTypography} sx={{whiteSpace: "normal", wordBreak: "break-all"}}>
                                    Press Enter to save {typedTriggerValue}
                                </Grid>
                            }
                        </Grid>
                    </Grid> 

                    <Grid item className={globalStyles.fullwidth}>
                        <Grid container gap={"10px"} alignItems={"center"} flexWrap={"nowrap"}>
                            <Grid item>
                                <Checkbox
                                    className={`${waCampaignStyles.checkBoxFilter} ${checkDisableTriggerKeywords("default") ? waCampaignStyles.defaultDisabledChatbotCheckBox : waCampaignStyles.defaultChatbotCheckBox}`}
                                    checked={createNewWorkflowPayload.chatbot_step_deployment_trigger_data?.find((trigger) => !(trigger.condition_group)) ? true: false}
                                    disableRipple 
                                    disabled={checkDisableTriggerKeywords("default")}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setCreateNewWorkflowPayload((prev) => ({
                                            ...prev, 
                                            chatbot_step_deployment_trigger_data: e.target.checked ? 
                                                [...prev?.chatbot_step_deployment_trigger_data, defaultConditionValueObject]
                                                : 
                                                prev?.chatbot_step_deployment_trigger_data?.filter((trigger) => (trigger.condition_group))
                                        }))
                                    }}
                                />
                            </Grid>
                            <Grid item className={styles.createWorkflowLabelStyle}>
                                Use this as a default chatbot (If no trigger matches)
                                <GlobalTooltip
                                    arrow
                                    placement='top'
                                    title={`Enable this if you want this chatbot to resopnd when no specific keyword or rule applies.`}
                                >
                                    <span className={`${globalStyles.clickable} ${waCampaignStyles.chatbotStepIButton}`}>
                                        <IconsColor fillColor={primaryColor} iconName="info" height={"14"} width={"14"} />
                                    </span>
                                </GlobalTooltip>
                            </Grid>
                        </Grid>
                    </Grid> 

                    <Grid item className={globalStyles.fullwidth}>
                        <Grid container direction={"column"} gap={"16px"}>
                            <Grid item className={styles.createWorkflowLabelStyle}>
                                Automatically Reset the thread after
                            </Grid>
                            <Grid item>
                                <Grid container gap={2} alignItems={"center"}>
                                    <Grid item>
                                        <Autocomplete
                                            className={`${globalStyles.autocompleteParaphrasing} ${styles.autoComplete}`}
                                            options={hours} 
                                            disableClearable
                                            value={String(createNewWorkflowPayload?.chatbot_thread_timeout_config?.timeout_duration?.hour) ?? null}
                                            onChange={(event, newValue) => onChangeOfTimer("hour", newValue)}
                                            getOptionLabel={(option) => String(option).padStart(2, '0')}
                                            isOptionEqualToValue={(option, value) => option === value}
                                            renderInput={(params) => (
                                                <TextField 
                                                    {...params} 
                                                    label="Hour" 
                                                    variant="outlined" 
                                                    size="small"  
                                                    className={styles.resetThreadTimerTextField}
                                                />
                                            )}
                                            size="small"
                                        />
                                    </Grid>
                                    <Grid item>
                                        <Autocomplete
                                            className={`${globalStyles.autocompleteParaphrasing} ${styles.autoComplete}`}
                                            options={minutes} 
                                            disableClearable
                                            value={String(createNewWorkflowPayload?.chatbot_thread_timeout_config?.timeout_duration?.min) ?? null}
                                            onChange={(event, newValue) =>  onChangeOfTimer("min", newValue)}
                                            getOptionLabel={(option) => String(option).padStart(2, '0')}
                                            isOptionEqualToValue={(option, value) => option === value} 
                                            getOptionDisabled={(option) => isMinuteDisabled(option, createNewWorkflowPayload?.chatbot_thread_timeout_config?.timeout_duration?.hour)}
                                            renderInput={(params) => (
                                                <TextField 
                                                    {...params} 
                                                    label="Minute" 
                                                    variant="outlined" 
                                                    size="small" 
                                                    className={styles.resetThreadTimerTextField}
                                                />
                                            )}
                                            size="small"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item className={globalStyles.fullwidth} mt={2} padding={"0px 0px 30px 0px"}>
                <Grid container direction={"row"} gap={2} justifyContent={"center"}>
                    <Grid item>
                        <GlobalButton buttonText={"Reset"} className='borderedButtonStyle' sx={{ minWidth: "130px", fontSize: largeScreen ? "13px !important" : "" }} onClick={() => handleResetNewFlow()} />
                    </Grid>
                    <Grid item>
                        <GlobalButton
                            buttonText={"Create"}
                            className='primaryButtonStyle'
                            sx={{ minWidth: "130px" }}
                            onClick={handleCreateWorkflow}
                            disabled={isCreateWorkflowDisabled()}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CreateWorkflowPopup
